import { FilterHandler } from 'app/shared/filter-handler';
import { Model } from './model';

import { Ship } from './ship';

export class CompetentAdministration extends Model {
  id: number;
  name: string;
  website: string;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new CompetentAdministration(values);
  }
}

export class ExpirationShips extends Model {
  id: number;
  name: string;
  type: string;
  competent_administration: CompetentAdministration;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new ExpirationShips(values);
  }
}

export class ShipExpirations extends Model {
  id: number;
  expiration: ExpirationShips;
  ship: Ship;
  expiration_date: Date;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const expiration = new ExpirationShips(values);

    return expiration;
  }
  public serialize() {
    const record = {};
    for (const key of Object.keys(this)) {
      record[key] = this[key];
    }

    return record;
  }
}

export class ExpirationFilter extends FilterHandler {
  id: string;
  expiration_date: string;
  // ship: string;
  // arte_de_pesca: string;

  constructor(values: Object = {}) {
    super();

    this.id = '';
    this.expiration_date = '';
    // this.sender = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/expiration.ts